define('businessServices/signup/signupSessionSingleton',[], function() {
    const SignupSessionSingleton = function() {
        if (SignupSessionSingleton.prototype._singletonInstance) {
            return SignupSessionSingleton.prototype._singletonInstance;
        }
        SignupSessionSingleton.prototype._singletonInstance = this;

        this.isLoaded = false;
        this.authorizedSignature = '';
        this.headerCarrier = ko.observable('');
        this.headerPhoneNumbers = ko.observable([]);
        this.isAcknowledged = false;
        this.isBypassNumberSelection = ko.observable(false);
        this.onboardingSelection = ko.observable('');
        this.isPackageDeepLinked = ko.observable(false);
        this.numberIntentSelection = ko.observable('');
        this.numberTypeSelection = ko.observable('');
        this.packageTypeSelection = ko.observable('');
        this.isTelephonyOnlyOffering = ko.observable(null);
        this.password = null;
        this.signupDocument = null;

        this.progressPercentage = ko.observable(0);
    };
    return new SignupSessionSingleton();
});
